import React from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
// import ShoppingCart from "../../images/shopping-cart.png"
// import {FaBook} from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { BsArrowLeftCircleFill } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';
const Navigation = () => {
  const navigate = useNavigate();
  //
  const handleNavLinkClick = () => {
    navigate('/');
  };

  return (
    <div>
      <Navbar color="transparent" light expand="md" className="emmaSkin p-0 d-none">
        {/*<NavbarBrand onClick={handleNavLinkClick}>*/}

        {/*    <img src={Logo} alt="Logo" className="navbar-logo" />*/}

        {/*</NavbarBrand>*/}

        {/*<Nav className="ml-auto" navbar>*/}
        {/*    <NavItem>*/}
        {/*        <NavLink href="/">Login/Sign Up</NavLink>*/}
        {/*    </NavItem>*/}
        {/*    <NavItem>*/}
        {/*        <NavLink onClick={handleNavLinkClick}> <FaBook className="redtext me-2"/> My Skin Diary </NavLink>*/}
        {/*    </NavItem>*/}
        {/*    <NavItem className="lineBar">*/}
        {/*        <NavLink href="/">*/}
        {/*            <img src={ShoppingCart} alt="Shopping Cart" className="cartShop" />*/}
        {/*        </NavLink>*/}
        {/*    </NavItem>*/}
        {/*    <NavItem>*/}
        {/*        <NavLink href="/">*/}
        {/*            <span className="text-danger"> EN </span> / ID*/}
        {/*        </NavLink>*/}
        {/*    </NavItem>*/}
        {/*</Nav>*/}
      </Navbar>
      <div className="d-none">
        <div className="d-flex justify-content-between px-3 icon-action p-3">
          <BsArrowLeftCircleFill size={22} />
          <IoClose size={27} />
        </div>
      </div>
    </div>
  );
};

export default Navigation;
